export const curatorRegionConstants = {
	CLEAR  : 'CLEAR_CONTROL',
	Create : {
		REQUEST : 'CREATE_CONTROL_REQUEST',
		SUCCESS : 'CREATE_CONTROL_SUCCESS',
		FAILURE : 'CREATE_CONTROL_FAILURE'
	},
	Update: {
		REQUEST : 'UPDATE_CONTROL_REQUEST',
		SUCCESS : 'UPDATE_CONTROL_SUCCESS',
		FAILURE : 'UPDATE_CONTROL_FAILURE'
	},
	Delete: {
		REQUEST : 'DELETE_CONTROL_REQUEST',
		SUCCESS : 'DELETE_CONTROL_SUCCESS',
		FAILURE : 'DELETE_CONTROL_FAILURE'
	},
	GetPaged: {
		REQUEST : 'GET_PAGED_CONTROL_REQUEST',
		SUCCESS : 'GET_PAGED_CONTROL_SUCCESS',
		FAILURE : 'GET_PAGED_CONTROL_FAILURE'
	}
}